<template>
    <v-container class="py-12">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span class="page-title">{{ page.title }}</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›"
                            :items="dataset.breadcrumbItems"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="save"
                            :loading="dataset.loading" v-if="page.isNew">Salvar</v-btn>
                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="update"
                            :loading="dataset.loading" v-if="!page.isNew">Atualizar</v-btn>
                        <v-btn id="btnBack" type="button" elevation="0" color="primary" outlined
                            to="/manutencoes/programacoes">Voltar</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-form ref="form" v-model="dataForm.validForm">
            <v-row>
                <v-col cols="12">
                    <v-card class="card-form-outlined">
                        <v-card-title class="card-group-title">Informações gerais</v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-text-field dense outlined label="Nome da programação"
                                        v-model="dataset.data.name" :rules="[$rules.required]"
                                        hide-details="auto"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-select dense outlined label="Tipo de manutenção"
                                        :items="resources.maintenanceTypes" item-text="label" item-value="value"
                                        v-model="dataset.data.maintenance_type" clearable
                                        hide-details="auto"></v-select>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-select dense outlined label="Fornecedor padrão" :items="resources.suppliers"
                                        item-text="name" item-value="id"
                                        v-model="dataset.data.default_supplier_id" clearable
                                        hide-details="auto"></v-select>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-switch inset dense label="Ativa" v-model="dataset.data.active"
                                        class="mt-1"></v-switch>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12">
                    <v-card class="card-form-outlined">
                        <v-card-title class="card-group-title">Gatilho e intervalo</v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" md="4">
                                    <v-select dense outlined label="Tipo de gatilho"
                                        :items="resources.triggerTypes" item-text="label" item-value="value"
                                        v-model="dataset.data.trigger_type" hide-details="auto"></v-select>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field dense outlined type="number" label="Intervalo"
                                        v-model="dataset.data.interval_value" min="1" :rules="[$rules.required]"
                                        hide-details="auto"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-select dense outlined label="Unidade" :items="resources.units"
                                        item-text="label" item-value="value"
                                        v-model="dataset.data.interval_unit" hide-details="auto"></v-select>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="3">
                                    <v-text-field dense outlined type="number" label="Tolerância"
                                        v-model="dataset.data.tolerance_value" min="0"
                                        hide-details="auto"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-select dense outlined label="Unidade tolerância" :items="resources.units"
                                        item-text="label" item-value="value"
                                        v-model="dataset.data.tolerance_unit" hide-details="auto"></v-select>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-text-field dense outlined type="number" label="Aviso antes de"
                                        v-model="dataset.data.notification_threshold_value" min="0"
                                        hint="Vazio ou zero: avisa quando faltar 10% do intervalo" persistent-hint
                                        hide-details="auto"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-select dense outlined label="Unidade aviso" :items="resources.units"
                                        item-text="label" item-value="value"
                                        v-model="dataset.data.notification_threshold_unit"
                                        hide-details="auto"></v-select>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-textarea dense outlined label="Descrição"
                                        v-model="dataset.data.description" rows="2" auto-grow
                                        hide-details="auto"></v-textarea>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12">
                    <v-card class="card-form-outlined">
                        <v-card-title class="card-group-title">Quais veículos recebem este item</v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" md="8">
                                    <v-radio-group v-model="dataset.data.scope" row hide-details class="mt-0">
                                        <v-radio v-for="scope in resources.scopes" :key="scope.value"
                                            :label="scope.label" :value="scope.value"></v-radio>
                                    </v-radio-group>
                                    <div class="caption grey--text mt-2">{{ scopeHint }}</div>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-select dense outlined label="Câmbio" :items="resources.transmissions"
                                        item-text="label" item-value="value" v-model="dataset.data.transmission"
                                        hint="Ex.: fluido de câmbio só para automáticos" persistent-hint
                                        hide-details="auto"></v-select>
                                </v-col>
                            </v-row>
                            <v-row v-if="dataset.data.scope === 'manual'">
                                <v-col cols="12">
                                    <v-autocomplete dense outlined multiple chips small-chips deletable-chips
                                        label="Selecione os veículos" :items="resources.vehicles"
                                        :item-text="vehicleLabel" item-value="id"
                                        v-model="dataset.data.vehicle_ids"
                                        :hint="`${(dataset.data.vehicle_ids || []).length} veículo(s) selecionado(s)`"
                                        persistent-hint hide-details="auto"></v-autocomplete>
                                </v-col>
                            </v-row>
                            <div v-else class="body-2 mt-4">
                                <v-icon small color="primary" class="mr-1">mdi-car-multiple</v-icon>
                                <strong>{{ matchingVehicles.length }}</strong> veículo(s) se encaixam hoje.
                                Novos veículos entram sozinhos ao serem cadastrados.
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12">
                    <v-card class="card-form-outlined">
                        <v-card-title class="card-group-title">
                            Intervalo por modelo
                            <v-spacer></v-spacer>
                            <span class="caption grey--text font-weight-regular">
                                Vale sobre o padrão ({{ defaultIntervalLabel }}); a exceção de um veículo vale sobre o modelo
                            </span>
                        </v-card-title>
                        <v-card-text>
                            <v-row dense align="center">
                                <v-col cols="12" md="4">
                                    <v-autocomplete dense outlined hide-details label="Marca" :items="brandOptions"
                                        v-model="newRule.brand" @change="newRule.vehicle_model_id = null"></v-autocomplete>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-autocomplete dense outlined hide-details label="Modelo" :items="newRuleModels"
                                        item-text="model" item-value="id" v-model="newRule.vehicle_model_id"
                                        :disabled="!newRule.brand"
                                        no-data-text="Todos os modelos desta marca já têm regra"></v-autocomplete>
                                </v-col>
                                <v-col cols="6" md="2">
                                    <v-text-field dense outlined hide-details type="number" min="1" label="Intervalo"
                                        :suffix="unitLabel" v-model="newRule.interval_value"></v-text-field>
                                </v-col>
                                <v-col cols="6" md="2">
                                    <v-btn block color="primary" outlined elevation="0" @click="addRule"
                                        :disabled="!newRule.vehicle_model_id || !(Number(newRule.interval_value) > 0)">
                                        <v-icon left small>mdi-plus</v-icon>Adicionar
                                    </v-btn>
                                </v-col>
                            </v-row>

                            <v-simple-table dense class="app-table mt-4" v-if="dataset.data.model_rules.length">
                                <thead>
                                    <tr>
                                        <th>Modelo</th>
                                        <th>Veículos</th>
                                        <th style="width: 170px">Intervalo</th>
                                        <th style="width: 170px">Aviso antes de</th>
                                        <th>Ativa</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(rule, index) in dataset.data.model_rules" :key="rule.vehicle_model_id">
                                        <td>
                                            <div class="font-weight-medium">{{ rule.model }}</div>
                                            <div class="caption grey--text">{{ rule.brand }}</div>
                                        </td>
                                        <td>{{ vehiclesOfModel(rule.vehicle_model_id) }}</td>
                                        <td>
                                            <v-text-field dense outlined hide-details type="number" min="1"
                                                :suffix="unitLabel" v-model="rule.interval_value"></v-text-field>
                                        </td>
                                        <td>
                                            <v-text-field dense outlined hide-details type="number" min="0"
                                                :suffix="unitLabel" placeholder="do item"
                                                v-model="rule.notification_threshold_value"></v-text-field>
                                        </td>
                                        <td><v-switch inset dense hide-details class="mt-0" v-model="rule.active"></v-switch></td>
                                        <td>
                                            <v-btn icon small @click="dataset.data.model_rules.splice(index, 1)">
                                                <v-icon small>mdi-delete-outline</v-icon>
                                            </v-btn>
                                        </td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                            <div v-else class="body-2 grey--text mt-4">
                                Nenhuma regra por modelo: todos os veículos usam o intervalo padrão.
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-form>
    </v-container>
</template>

<script>
import axios from 'axios'

export default {
    name: 'PreventiveSchedulingDetails',

    data: () => ({
        page: {
            title: '',
            isNew: true,
        },
        dataset: {
            data: {
                name: '',
                description: '',
                maintenance_type: null,
                default_supplier_id: null,
                trigger_type: 'odometer',
                interval_value: null,
                interval_unit: 'km',
                tolerance_value: 0,
                tolerance_unit: 'km',
                notification_threshold_value: 0,
                notification_threshold_unit: 'km',
                active: true,
                scope: 'all',
                transmission: null,
                vehicle_ids: [],
                model_rules: [],
            },
            breadcrumbItems: [],
            loading: false,
        },
        dataForm: {
            validForm: true,
        },
        resources: {
            maintenanceTypes: [],
            suppliers: [],
            vehicles: [],
            triggerTypes: [],
            units: [],
            models: [],
            scopes: [],
            transmissions: [],
        },
        newRule: {
            brand: null,
            vehicle_model_id: null,
            interval_value: null,
        },
    }),

    computed: {
        unitLabel() {
            const unit = (this.resources.units || []).find((item) => item.value === this.dataset.data.interval_unit)
            return unit ? unit.label : ''
        },

        defaultIntervalLabel() {
            const value = Number(this.dataset.data.interval_value)
            return value ? `${value.toLocaleString('pt-BR')} ${this.unitLabel}` : 'sem intervalo'
        },

        scopeHint() {
            const hints = {
                all: 'Todos os veículos recebem o item; os modelos com regra usam o intervalo próprio.',
                models: 'Somente veículos dos modelos listados abaixo recebem o item.',
                manual: 'Somente os veículos escolhidos recebem o item.',
            }
            return hints[this.dataset.data.scope] || ''
        },

        brandOptions() {
            const brands = new Set(this.resources.models.map((item) => item.brand || 'Sem marca'))
            return [...brands].sort((a, b) => a.localeCompare(b, 'pt-BR'))
        },

        newRuleModels() {
            const used = new Set(this.dataset.data.model_rules.map((rule) => rule.vehicle_model_id))
            return this.resources.models.filter((item) => (item.brand || 'Sem marca') === this.newRule.brand && !used.has(item.id))
        },

        matchingVehicles() {
            const transmission = this.dataset.data.transmission
            const ruleModels = new Set(this.dataset.data.model_rules.filter((rule) => rule.active).map((rule) => rule.vehicle_model_id))
            return this.resources.vehicles.filter((vehicle) => {
                if (transmission && vehicle.transmission !== transmission) return false
                if (this.dataset.data.scope === 'models') return ruleModels.has(vehicle.vehicle_model_id)
                return true
            })
        },
    },

    created() {
        this.loadData()
    },

    methods: {
        async loadData() {
            this.setPage()
            this.listBreadCrumbItems()
            await this.loadResources()

            if (!this.page.isNew) {
                await this.load()
            }
        },

        goBack() {
            this.$router.replace('/manutencoes/programacoes')
        },

        setPage() {
            this.page.isNew = this.$route.params.id === 'novo'
            this.page.title = this.page.isNew ? 'Nova programação' : 'Editar programação'
        },

        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                { text: 'Homepage', disabled: false, to: '/home', exact: true },
                { text: 'Manutenções', disabled: false, to: '/manutencoes', exact: true },
                { text: 'Programações', disabled: false, to: '/manutencoes/programacoes', exact: true },
                { text: this.page.isNew ? 'Nova programação' : 'Editar programação', disabled: true, exact: true },
            ]
        },

        vehiclesOfModel(modelId) {
            return this.resources.vehicles.filter((vehicle) => vehicle.vehicle_model_id === modelId).length
        },

        addRule() {
            const model = this.resources.models.find((item) => item.id === this.newRule.vehicle_model_id)
            if (!model) return
            this.dataset.data.model_rules.push({
                vehicle_model_id: model.id,
                brand: model.brand,
                model: model.model,
                interval_value: Number(this.newRule.interval_value),
                notification_threshold_value: null,
                active: true,
            })
            this.newRule = { brand: this.newRule.brand, vehicle_model_id: null, interval_value: this.newRule.interval_value }
        },

        buildPayload() {
            const data = this.dataset.data
            return {
                ...data,
                transmission: data.transmission || null,
                notification_threshold_value: Number(data.notification_threshold_value) || 0,
                vehicle_ids: data.scope === 'manual' ? data.vehicle_ids : undefined,
                replace_vehicle_links: data.scope === 'manual',
                model_rules: data.model_rules.map((rule) => ({
                    vehicle_model_id: rule.vehicle_model_id,
                    interval_value: Number(rule.interval_value),
                    notification_threshold_value: rule.notification_threshold_value === '' || rule.notification_threshold_value === null
                        ? null
                        : Number(rule.notification_threshold_value),
                    active: rule.active !== false,
                })),
            }
        },

        vehicleLabel(item) {
            if (!item) return ''
            return `${item.plate || 'Sem placa'} - ${item.brand || ''} ${item.model || ''}`.trim()
        },

        async loadResources() {
            try {
                const { data } = await axios.get('/api/v2/maintenance/schedulings/resources')
                this.resources = data?.content || this.resources
            } catch (error) {
                this.$dialog.notify.error(this.$codes ? this.$codes(error) : 'Erro ao carregar recursos.', {
                    position: 'top-right', timeout: 5000,
                })
            }
        },

        async load() {
            this.dataset.loading = true
            try {
                const { data } = await axios.get(`/api/v2/maintenance/schedulings/${this.$route.params.id}`)
                const item = data?.content || {}

                this.dataset.data = {
                    name: item.name || '',
                    description: item.description || '',
                    maintenance_type: item.maintenance_type,
                    default_supplier_id: item.default_supplier_id,
                    trigger_type: item.trigger_type,
                    interval_value: item.interval_value,
                    interval_unit: item.interval_unit,
                    tolerance_value: item.tolerance_value,
                    tolerance_unit: item.tolerance_unit,
                    notification_threshold_value: item.notification_threshold_value,
                    notification_threshold_unit: item.notification_threshold_unit,
                    active: item.active !== false,
                    scope: item.scope || 'manual',
                    transmission: item.transmission || null,
                    vehicle_ids: (item.vehicles || []).map((v) => v.vehicle_id),
                    model_rules: (item.model_rules || []).map((rule) => ({ ...rule, active: rule.active !== false })),
                }
            } catch (error) {
                this.$dialog.notify.error('Erro ao carregar a programação.', { position: 'top-right', timeout: 5000 })
            } finally {
                this.dataset.loading = false
            }
        },

        async save() {
            if (!this.$refs.form.validate()) return

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja salvar a programação?',
                title: 'Salvar programação',
                actions: { false: 'Cancelar', true: 'Salvar' },
            })

            if (!proceedAction) return

            this.dataset.loading = true

            try {
                const payload = this.buildPayload()
                await axios.post('/api/v2/maintenance/schedulings', payload)

                this.$dialog.notify.info('Programação criada com sucesso.', { position: 'top-right', timeout: 2000 })

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes ? this.$codes(error) : 'Erro ao salvar programação.', {
                    position: 'top-right', timeout: 5000,
                })
            } finally {
                this.dataset.loading = false
            }
        },

        async update() {
            if (!this.$refs.form.validate()) return

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja atualizar a programação?',
                title: 'Atualizar programação',
                actions: { false: 'Cancelar', true: 'Atualizar' },
            })

            if (!proceedAction) return

            this.dataset.loading = true

            try {
                const payload = this.buildPayload()
                await axios.patch(`/api/v2/maintenance/schedulings/${this.$route.params.id}`, payload)

                this.$dialog.notify.info('Programação atualizada com sucesso.', { position: 'top-right', timeout: 2000 })

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes ? this.$codes(error) : 'Erro ao atualizar programação.', {
                    position: 'top-right', timeout: 5000,
                })
            } finally {
                this.dataset.loading = false
            }
        },
    },
}
</script>
